import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import { pipSetAccessToken, pipGetAccessToken } from "../../auth/Pip";
import {
    loginEndPointURL,
    signupEndPointURL,
    forgotPasswordEndPointURL,
    bussinessProfileEndPointURL,
    changePasswordEndPointURL,
    updateBussinessProfileEndPointURL,
    getDashboardDataEndPointURL,
    deleteImageEndPointURL,
    notificationEndPointURL,
    getAllSubscriptionPlansEndPoitnURL,
    getMySubscriptionPlansEndPoitnURL,
    cancelSubscriptionPlansEndPointURL,
    getSubscriptionHistoryEndPointURL,
    purchaseNewSubscriptionPlanEndPointURL,
    upgradeSubscriptionPlanEndPointURL,
    getXerologinDataENDPOINTURL,
    pushInvoiceToXeroENDPOINTURL,
    tooltipSeenEndPointURL,
} from "../../routes/BackendRoutes";

export const markTooltipSeen = createAsyncThunk(
    "mark-tooltip-seen",
    async (props) => {
        const { payload = {}, callback = () => { }, isErrorToast = false } =
            props || {};
        try {
            const response = await API_REQUEST({
                url: tooltipSeenEndPointURL,
                method: "PATCH",
                data: payload,
                isErrorToast,
                isSuccessToast: false,
            });
            callback(response);
            return response;
        } catch (error) {
            callback(null, error);
        }
    },
);

export const userSignUp = createAsyncThunk("auth-signup", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: signupEndPointURL,
            method: "POST",
            data: payload,
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const userLogin = createAsyncThunk("auth-login", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: loginEndPointURL,
            method: "POST",
            data: payload,
        });
        pipSetAccessToken(response?.data?.token);
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const userForgotPassword = createAsyncThunk("auth-forgot-password", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: forgotPasswordEndPointURL,
            method: "POST",
            data: payload,
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const getBussinessProfileData = createAsyncThunk("get-profile", async (props) => {
    try {
        const response = await API_REQUEST({
            url: bussinessProfileEndPointURL,
            method: "GET",
            isErrorToast: false
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

export const updateBussinessProfile = createAsyncThunk("update-profile", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: updateBussinessProfileEndPointURL,
            method: "POST",
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const changePassword = createAsyncThunk(
    "change-password",
    async (props) => {
        const { payload, callback } = props;

        try {
            const token = pipGetAccessToken();
            const response = await API_REQUEST({
                url: changePasswordEndPointURL,
                method: "POST",
                data: {
                    token,
                    current_password: payload.current_password,
                    password: payload.password,
                    confirm_password: payload.confirm_password,
                },
            });
            callback?.(response);
            return response;
        } catch (error) {
            callback?.(null, error);
        }
    }
);

export const getDashboardData = createAsyncThunk("dashboard-data", async () => {
    try {
        const response = await API_REQUEST({
            url: getDashboardDataEndPointURL,
            method: "GET",
            isErrorToast: false
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

export const updateBussinessImage = createAsyncThunk("update-img", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: deleteImageEndPointURL + `/${payload}`,
            method: "DELETE",
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const getNotificationData = createAsyncThunk("notification-data", async () => {
    try {
        const response = await API_REQUEST({
            url: notificationEndPointURL,
            method: "GET",
            isErrorToast: false
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

export const getAllSubscriptionPlan = createAsyncThunk("get-plan", async () => {
    try {
        const response = await API_REQUEST({
            url: getAllSubscriptionPlansEndPoitnURL,
            method: "GET",
            isErrorToast: false
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

export const getUserSubscriptionPlan = createAsyncThunk("get-user-plan", async () => {
    try {
        const response = await API_REQUEST({
            url: getMySubscriptionPlansEndPoitnURL,
            method: "GET",
            isErrorToast: false
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

export const cancelSubscriptionPlan = createAsyncThunk("cancel-subscription", async (props) => {
    const { callback } = props;
    try {
        const response = await API_REQUEST({
            url: cancelSubscriptionPlansEndPointURL,
            method: "POST",
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const getSubscriptionPlanHistory = createAsyncThunk("get-history-plan", async () => {
    try {
        const response = await API_REQUEST({
            url: getSubscriptionHistoryEndPointURL,
            method: "GET",
            isErrorToast: false
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

export const purchaseSubscriptionPlan = createAsyncThunk("purchase-subscription", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: purchaseNewSubscriptionPlanEndPointURL,
            method: "POST",
            data: payload,
            isSuccessToast: false
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const upgradeSubscriptionPlan = createAsyncThunk("upgrade-subscription", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: upgradeSubscriptionPlanEndPointURL,
            method: "POST",
            data: payload,
            isSuccessToast: false
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const getXeroLoginLink = createAsyncThunk("xero-login", async () => {
    try {
        const response = await API_REQUEST({
            url: getXerologinDataENDPOINTURL,
            method: "GET"
        });
        return response;
    } catch (error) {
        console.log(error)
    };
});

// pushInvoiceToXeroENDPOINTURL
export const pushInvoiceToXeroAction = createAsyncThunk("push-invoice-xero", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: pushInvoiceToXeroENDPOINTURL,
            method: "POST",
            data: payload
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});

export const respondToSupplierOffer = createAsyncThunk("respond-supplier-offer", async (props) => {
    const { payload, callback } = props;
    try {
        const response = await API_REQUEST({
            url: "users/respondToReceivedOffer",
            method: "POST",
            data: payload
        });
        callback(response);
        return response;
    } catch (error) {
        callback(null, error);
    };
});


